module.exports = __webpack_public_path__ + "static/media/mia-khalifa-icon.d9ecc459.jpg";